"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as a, jsx as h } from "react/jsx-runtime";
import { useTheme as o } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: l, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const r = n(), v = l !== null && l !== void 0 ? l : r ? i.colors.inverse : i.colors.neutralHigh, { skinName: t } = o();
    return t.match(/^blau/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ h("path", {
                fill: v,
                d: "M17.21 16.699h1.98v1.98h-1.98z"
            }),
            /* @__PURE__ */ h("path", {
                fill: v,
                d: "M19.655 8.048h.8a1.544 1.544 0 0 1 1.543 1.563v9.864a1.55 1.55 0 0 1-1.547 1.548h-4.508a1.55 1.55 0 0 1-1.544-1.544v-2.244H2.548L2 16.139l2-2.676V3h15.655zm-1.352-3.68H5.376v8.66h9.023V9.61a1.543 1.543 0 0 1 1.56-1.563h2.344zM5.032 14.375l-1.116 1.492h10.483v-1.492zm15.546 5.219a.18.18 0 0 0 .053-.127V9.61a.176.176 0 0 0-.177-.176H15.96a.18.18 0 0 0-.18.176v9.86a.18.18 0 0 0 .18.176h4.492a.18.18 0 0 0 .127-.053"
            })
        ]
    })) : t.match(/^o2-new/i) ? /* @__PURE__ */ h("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ h("path", {
            fill: v,
            d: "M19.884 2h-4.926c-1.161 0-2.111.964-2.111 2.144V4.5H5.112C3.95 4.5 3 5.464 3 6.644v13.213C3 21.036 3.95 22 5.112 22h9.85c1.162 0 2.112-.964 2.112-2.143v-3.57h2.814c1.162 0 2.112-.964 2.112-2.143v-10C21.995 2.964 21.046 2 19.884 2m-5.628 3.574h6.33v7.139h-6.33zm5.628-2.143c.387 0 .702.32.702.713V4.5h-6.33v-.356c0-.394.315-.713.702-.713zM5.112 5.93h7.74V7H4.404v-.356c0-.357.35-.713.707-.713m0 14.639c-.352 0-.703-.357-.703-.713V19.5h11.256v.357c-.004.356-.355.713-.707.713zm10.549-2.144H4.405V8.074h8.442v6.07c0 1.179.95 2.143 2.111 2.143h.703zm-.703-3.57a.71.71 0 0 1-.702-.713v-.356h6.33v.356a.71.71 0 0 1-.702.713z"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ h("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ h("path", {
            fill: v,
            d: "M19.884 2h-4.926c-1.161 0-2.111.964-2.111 2.144V4.5H5.112C3.95 4.5 3 5.464 3 6.644v13.213C3 21.036 3.95 22 5.112 22h9.85c1.162 0 2.112-.964 2.112-2.143v-3.57h2.814c1.162 0 2.112-.964 2.112-2.143v-10C21.995 2.964 21.046 2 19.884 2m-5.628 3.574h6.33v7.139h-6.33zm5.628-2.143c.387 0 .702.32.702.713V4.5h-6.33v-.356c0-.394.315-.713.702-.713zM5.112 5.93h7.74V7H4.404v-.356c0-.357.35-.713.707-.713m0 14.639c-.352 0-.703-.357-.703-.713V19.5h11.256v.357c-.004.356-.355.713-.707.713zm10.549-2.144H4.405V8.074h8.442v6.07c0 1.179.95 2.143 2.111 2.143h.703zm-.703-3.57a.71.71 0 0 1-.702-.713v-.356h6.33v.356a.71.71 0 0 1-.702.713z"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ h("path", {
                fill: v,
                d: "M18.278 17.32c-.285 0-.456-.112-.549-.208a.75.75 0 0 1-.199-.54c0-.457.294-.75.748-.75s.748.293.748.75c0 .28-.106.448-.199.54a.75.75 0 0 1-.549.208"
            }),
            /* @__PURE__ */ h("path", {
                fill: v,
                d: "M14.715 16.922H5.446c-1.098 0-1.94-.328-2.504-.97-.524-.599-.787-1.467-.787-2.582V8.432c0-1.115.266-1.983.787-2.583.563-.644 1.404-.97 2.504-.97h10.09c1.098 0 1.941.329 2.504.97.524.6.787 1.468.787 2.583v.008h.922c1.37 0 2.095.726 2.095 2.095v6.49c-.003 1.37-.725 2.096-2.098 2.096h-2.935c-1.37 0-2.096-.726-2.096-2.095zm0-1.118v-5.269c0-1.35.745-2.095 2.096-2.095h.896v-.008c0-.835-.171-1.457-.513-1.846-.344-.395-.888-.588-1.658-.588H5.446c-.77 0-1.313.193-1.658.588-.339.39-.513 1.011-.513 1.846v4.938c0 .835.171 1.457.513 1.846.345.395.888.588 1.658.588zm2.096-6.246c-.729 0-.975.246-.975.975v6.49c0 .375.07.636.207.773q.206.203.77.204h2.939q.564 0 .77-.204c.137-.134.207-.395.207-.773v-6.488c0-.747-.227-.974-.974-.974H16.81z"
            }),
            /* @__PURE__ */ h("path", {
                fill: v,
                d: "M7.897 19.124h4.916a.56.56 0 1 0 0-1.12H7.897a.56.56 0 0 0-.56.56c0 .308.252.56.56.56"
            })
        ]
    }));
}, V = m;
export { V as default };
